import { createContext, useContext, useEffect, useState } from "react";
import { api, setToken } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
    const out = () => { setToken(null); setUser(false); };
    window.addEventListener("vavlis:signedout", out);
    return () => window.removeEventListener("vavlis:signedout", out);
  }, []);

  useEffect(() => {
    if (!user || user.type !== "customer") return undefined;
    const check = () => api.get("/auth/me").catch(() => {});  // a deactivated company signs its users out
    const id = setInterval(check, 60000);
    window.addEventListener("focus", check);
    return () => { clearInterval(id); window.removeEventListener("focus", check); };
  }, [user]);

  const startSession = (data) => {
    setToken(data.access_token);
    setUser(data.user);
    return data.user;
  };

  const login = async (email, password, remember) => startSession((await api.post("/auth/login", { email, password, remember })).data);

  const loginWithCode = async (email, code, remember) => startSession((await api.post("/auth/login-code/verify", { email, code, remember })).data);

  const logout = async () => {
    sessionStorage.removeItem("vavlis.viewas");
    try {
      await api.post("/auth/logout");
    } finally {
      setToken(null);
      setUser(false);
    }
  };

  const viewAs = async (code, name, userId) => {
    const { data } = await api.post("/auth/view-as", { customer_code: code, user_id: userId || null });
    sessionStorage.setItem("vavlis.viewas", JSON.stringify({ code, name }));
    startSession(data);
  };

  const exitViewAs = async () => {
    const v = JSON.parse(sessionStorage.getItem("vavlis.viewas") || "{}");
    await api.post("/auth/view-as/stop").catch(() => {});
    sessionStorage.removeItem("vavlis.viewas");
    setToken(null);
    try {
      const { data } = await api.post("/auth/refresh");
      setToken(data.access_token);
      setUser((await api.get("/auth/me")).data);
    } catch (e) { setUser(false); }
    return v.code;
  };

  return <AuthContext.Provider value={{ user, login, loginWithCode, logout, viewAs, exitViewAs }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
